<template>
  <header class="card-header">
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: "CardHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.card-header {
  padding: 18px;
  border-radius: 10px 10px 0 0;
  font-size: 16px;
  font-weight: bold;
  @include mq-up(md) {
    padding: 25px;
    font-size: 20px;
  }
  > :deep(.flex) {
    @include flex(flex, flex-start, center, row, wrap);
  }
  :deep(.heading) {
    font-size: 16px;
    font-weight: bold;
    @include mq-up(md) {
      font-size: 20px;
    }
  }
}
.-image-top {
  .card-header {
    padding: 0;
    > :deep(.heading) {
      font-weight: normal;
      padding: 15px 0;
    }
  }
}
</style>
